
<div class="modal-custom">

  <div class="modal-body">
    <div class="font-weight-bold">MatrixCare 360 Seeding could not be enabled at this time due to the following reason: </div>
    <br>
      <div >{{message.message}}</div>
    <br>
    <div class="font-weight-bold">Please try again later.</div>
    <div class="modal-footer mt-0">
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="close()">Okay</button>
    </div>
  </div>

</div>
